import CalendarItemRecurrenceDeleteConfirmation from "./CalendarItemRecurrenceDeleteConfirmation"
export default CalendarItemRecurrenceDeleteConfirmation
